import React from "react";

const handleContactlessPayments = (props) => {
  const options = [
    {
      text: 'Comment les paiements sans contact,  et par puce et NIP par Débit Interac fonctionnent-ils?',
      handler: props.actionProvider.handleContactlessPayments1,
      id: 1,
    },
    {
      text: 'Dans quelle mesure les paiements sans contact,  et les paiements par puce et NIP sont-ils sécuritaires?',
      handler: props.actionProvider.handleContactlessPayments2,
      id: 2
    },
    {
      text: 'Quelles sont les mesures en vigueur pour me protéger contre les transactions frauduleuses avec les paiements sans contact et, par puce et NIP par Débit INTERAC?',
      handler: props.actionProvider.handleContactlessPayments3,
      id: 3
    },
    {
      text: 'Que signifie « dans la mesure où vous avez pris des mesures raisonnables pour protéger votre carte et votre NIP »?',
      handler: props.actionProvider.handleContactlessPayments4,
      id: 4
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container requestmoney-products'>{optionsMarkup}</div>;
};

export default handleContactlessPayments;